import React, { Component } from 'react';
import { Toast } from 'react-bootstrap';
import NetworkHeartService from 'network-heart-service';

import { getLengthByType } from '../../../api/length_by_type';
import { getLengthBySize } from '../../../api/length_by_size';
import { getLengthByTypeDMA } from '../../../api/length_by_type_DMA';
import { getLengthBySizeDMA } from '../../../api/length_by_size_DMA';
import { getToken } from '../../../api/get_token';


// import { dummyDataLengthByTypeDMA, dummyDataLengthBySizeDMA, noDummyDataLengthByTypeDMA, noDummyDataLengthBySizeDMA } from './dummy_data';

import WrapperSearchBox from '../../content/pipeline-detail/wrapper-search-box/wrapper-search-box.component';
import WrapperTotal from '../../content/pipeline-detail/wrapper-total/wrapper-total.component';
import WrapperListDMA from '../../content/pipeline-detail/wrapper-list-DMA/wrapper-list-DMA.component';

class PipelineDetailPage extends Component {
    constructor(props) {
        super();

        this.state = {
            lengthByType: [],
            lengthBySize: [],
            lengthByTypeDMA: [],
            lengthBySizeDMA: [],
            loading: false,
            loadingDMAList: false,
            hasData: true,
            showToast: false,
            textInToast: '',
            failColorToast: '#DCBF85',
            colorToast: '#F5F8DE'
        }
    }

    closeToast = () => this.setState({ showToast: false });

    opentToast = () => this.setState({ showToast: true });

    searchAllByMonthYear = async (monthSearch, yearSearch) => {

        const isOnline = await NetworkHeartService.isOnline();
        if (!isOnline) {
            this.setState({ textInToast: 'Oh, may be you went offline, please check you connection!', colorToast: '#DCBF85' })
            this.opentToast();
            return;
        }

        this.setState({ loading: true, loadingDMAList: true });

        const resGetToken = await getToken();
        const token = resGetToken.data.token;
        const whereClause = `MONTH = ${monthSearch} and YEAR = ${yearSearch}`;
        const resGetLengthByType = await getLengthByType(token, whereClause);

        if (!(Array.isArray(resGetLengthByType.data.features) && resGetLengthByType.data.features.length)) {
            this.setState({ hasData: false, loading: false, loadingDMAList: false, lengthByType: [], lengthBySize: [], lengthByTypeDMA: [], lengthBySizeDMA: [] })
            this.setState({ textInToast: 'No data found!', colorToast: '#DCBF85' })
            this.opentToast();
            return;
        }

        const resGetLengthBySize = await getLengthBySize(token, whereClause);

        // console.log('resGetLengthBySize.data.features ',resGetLengthBySize.data.features);

        this.setState({
            lengthByType: resGetLengthByType.data.features,
            lengthBySize: resGetLengthBySize.data.features,
            hasData: true,
            loading: false
        });

        const resGetLengthByTypeDMA = await getLengthByTypeDMA(token, whereClause);

        const resGetLengthBySizeDMA = await getLengthBySizeDMA(token, whereClause);

        this.setState({
            lengthByTypeDMA: resGetLengthByTypeDMA.data.features,
            lengthBySizeDMA: resGetLengthBySizeDMA.data.features,
            loadingDMAList: false
        });
    }

    componentDidMount = async () => {
        try {
        } catch (e) {
            //handle error
            console.log('Error get length by type: ', e);
        }
    }

    render() {
        
        return (
            <div className="wrapper-dashboard-page">
                <h1 className="page-name-header">Pipe Details</h1>
                {/* <p className="content-test">Lorem ipsum dolor sit amet, consectetur adipiscing elit. ae risus tristique posuere.</p> */}
                <WrapperSearchBox searchFromParent={this.searchAllByMonthYear} ></WrapperSearchBox>
                <WrapperTotal
                    dataLengthByType={this.state.lengthByType}
                    dataLengthBySize={this.state.lengthBySize}
                    loading={this.state.loading}
                    hasData={this.state.hasData}>
                </WrapperTotal>
                <WrapperListDMA
                    dataLengthByTypeDMA={this.state.lengthByTypeDMA}
                    dataLengthBySizeDMA={this.state.lengthBySizeDMA}
                    loadingDMAList={this.state.loadingDMAList}
                />

                <div style={{
                    position: 'fixed',
                    bottom: '10px',
                    right: '2px',
                }}>
                    <Toast onClose={this.closeToast} show={this.state.showToast} delay={3000} autohide>
                        <Toast.Header>
                            <img
                                // src="holder.js/20x20?text=%20"
                                className="rounded mr-2"
                                alt=""
                            />
                            <strong className="mr-auto">NRW Management</strong>
                            {/* <small>11 mins ago</small> */}
                        </Toast.Header>
                        <Toast.Body style={{ backgroundColor: `${this.state.colorToast}` }}>{this.state.textInToast}</Toast.Body>
                    </Toast>
                </div>

            </div>
        )
    }
}

export default PipelineDetailPage
